import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import { ReactiveVar } from 'meteor/reactive-var'
import { Meteor } from 'meteor/meteor'

import { TextField } from '@material-ui/core'
import { toast } from 'react-toastify'
import { fetchOffers } from '../lib/offers'
import useTracker from '../lib/useTracker'
import Button from './Button'

export const CodePromo = new ReactiveVar()

const CodeTyper = () => {
  const [value, setValue] = useState('')
  const { formatMessage } = useIntl()

  const codeApplied = useTracker(() => CodePromo.get(), [])

  const handleChange = ({ target: { value } }) => setValue(value)

  const handleSubmit = () => {
    const valueTrimmed = value.trim()

    CodePromo.set(valueTrimmed)
    fetchOffers()
    toast.success(
      formatMessage({ id: 'CodeTyper.valid', defaultMessage: 'Le code promo a été appliqué' })
    )
  }

  const handleErase = () => {
    CodePromo.set('')
    fetchOffers()
  }

  const endAdornment = codeApplied ? (
    <Button onClick={handleErase} color={'decline'} style={{ marginRight: -6 }}>
      Supprimer
    </Button>
  ) : (
    <Button onClick={handleSubmit} color={'decline'} style={{ marginRight: -6 }}>
      Ajouter
    </Button>
  )

  const startAdornment = codeApplied ? (
    <CheckCircleIcon style={{ color: '#43BC23', marginRight: 8 }} />
  ) : null

  return (
    <TextField
      fullWidth
      value={codeApplied || value}
      onChange={handleChange}
      disabled={!!codeApplied}
      style={{ marginTop: 16, background: 'white', borderRadius: 4 }}
      placeholder={formatMessage({ id: 'CodeTyper.placeholder', defaultMessage: 'Code promo' })}
      InputProps={{
        startAdornment,
        endAdornment,
      }}
    />
  )
}

export default CodeTyper
